import DetailsPublish from "./DetailsPublish";

export default DetailsPublish;
